var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"btn-sm btn-export btn-neutral",attrs:{"size":"sm"},on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.generating)?_c('b-spinner',{staticClass:"mr-2",attrs:{"small":""}}):_c('font-awesome-icon',{staticClass:"mr-2",attrs:{"icon":"fas fa-file-export"}}),_vm._v(_vm._s(_vm.text ? _vm.text : 'Export'))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }